export default __webpack_public_path__ + "static/media/star-filled.359dc9f5.svg";